// Theme Optimized - Performance-optimized JavaScript
// Move this to: assets/theme-optimized.js

/**
 * MARQUEE ANIMATION
 * Optimized marquee text animation for header banners
 */
function startMarquee(id, pathId, content, speed) {
  const textPath = document.getElementById(id);
  const path = document.getElementById(pathId);
  
  if (!textPath || !path) return;
  
  const pathLength = path.getTotalLength();
  textPath.innerHTML = content;

  let offset = 0;
  let animationId = null;

  function animateText() {
    offset -= speed;
    if (offset < 0) {
      offset = pathLength;
    } else if (offset > pathLength) {
      offset = 0;
    }
    textPath.setAttribute('startOffset', `${offset}px`);
    animationId = requestAnimationFrame(animateText);
  }

  animateText();
  
  // Optional: Add cleanup on page unload
  window.addEventListener('beforeunload', () => {
    if (animationId) cancelAnimationFrame(animationId);
  });
}

/**
 * STICKY HEADER COLOR OPTIMIZATION
 * Updates header colors based on page location
 */
function optimizeStickyHeader() {
  if (window.location.pathname === '/') return; // Skip on homepage
  
  const stickyHeader = document.querySelector('.sticky-header-color');
  const utilityBar = document.querySelector('.utility-bar');
  const headerLogo = document.querySelector('img.header__heading-logo.motion-reduce');

  if (stickyHeader) {
    stickyHeader.classList.remove('color-scheme-4');
    stickyHeader.classList.add('color-scheme-1');
  }

  if (utilityBar) {
    utilityBar.classList.remove('color-scheme-4');
    utilityBar.classList.add('color-scheme-1');
  }

  if (headerLogo) {
    headerLogo.style.filter = 'brightness(0) saturate(0)';
  }
}

/**
 * FADE-IN SECTION OBSERVER
 * Optimized Intersection Observer for fade-in animations
 */
function initFadeInObserver() {
  const fadeInSections = document.querySelectorAll('.fade-in');
  
  if (fadeInSections.length === 0) return;

  const options = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px' // Start fade-in 50px before element comes into view
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        // Optional: Stop observing after animation to save memory
        // observer.unobserve(entry.target);
      }
    });
  }, options);

  fadeInSections.forEach(section => {
    observer.observe(section);
  });

  return observer;
}

/**
 * FUNNEL MODE FOR KHAYAL1TOP.COM
 * Manages special funnel page behavior
 */
function initFunnelMode() {
  if (!window.location.hostname.includes("khayal1top.com")) return;
  
  document.documentElement.classList.add("funnel-mode");
  sessionStorage.setItem("funnelVisitor", "true");
}

/**
 * MAIN INITIALIZATION
 * Runs all optimizations when DOM is ready
 */
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all optimizations
  const textContent1 = '100% Natural <tspan fill="#E1A13F">✦</tspan> Cruelty Free <tspan fill="#E1A13F">✦</tspan> Made in India <tspan fill="#E1A13F">✦</tspan> ISO Certified <tspan fill="#E1A13F">✦</tspan>'.repeat(5);
  
  // Only start marquee if elements exist
  if (document.getElementById('marquee-text') && document.getElementById('text-path')) {
    startMarquee('marquee-text', 'text-path', textContent1, -2);
  }
  if (document.getElementById('marquee-text2') && document.getElementById('text-path')) {
    startMarquee('marquee-text2', 'text-path', textContent1, -2);
  }
  if (document.getElementById('marquee-text3') && document.getElementById('text-path')) {
    startMarquee('marquee-text3', 'text-path', textContent1, -2);
  }

  // Optimize sticky header
  optimizeStickyHeader();

  // Initialize fade-in observer
  initFadeInObserver();

  // Initialize funnel mode if applicable
  initFunnelMode();
});

/**
 * WINDOW SCROLL OPTIMIZATION
 * Debounced scroll event handler for better performance
 */
let scrollTimeout;
window.addEventListener('scroll', () => {
  if (scrollTimeout) {
    window.cancelAnimationFrame(scrollTimeout);
  }
  scrollTimeout = window.requestAnimationFrame(() => {
    // Add scroll-specific logic here if needed
    // This pattern prevents excessive reflows/repaints
  });
}, { passive: true });

/**
 * PERFORMANCE MONITORING (Optional)
 * Uncomment to log performance metrics
 */
/*
if (window.performance && window.performance.timing) {
  window.addEventListener('load', () => {
    const perfData = window.performance.timing;
    const pageLoadTime = perfData.loadEventEnd - perfData.navigationStart;
    const connectTime = perfData.responseEnd - perfData.requestStart;
    const renderTime = perfData.domComplete - perfData.domLoading;
    
    console.log('Page Load Time:', pageLoadTime, 'ms');
    console.log('Connect Time:', connectTime, 'ms');
    console.log('Render Time:', renderTime, 'ms');
  });
}
*/

// Export for testing (optional)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    startMarquee,
    optimizeStickyHeader,
    initFadeInObserver,
    initFunnelMode
  };
}
